import { Button, Col, Form, Image, Modal, Row, Spin } from 'antd';
import { observer } from 'mobx-react';
import useStore from '../../../../store';
import Message from '../../../../config/Message';
import { useState } from 'react';
import InputComponent from '../../../../component/InputComponent';
import { Notification } from '../../../../config/Global';

const PropertyImageApproveModal = observer((props) => {
	const { visible, onClose, merchantId } = props;
	const [form] = Form.useForm();
	const {
		ACCOMMODATION,
		AUTH,
		ACCOMMODATION: { propertyImageDetails },
	} = useStore();
	const [imageData, setImageData] = useState([]);
	const [disabled, setDisabled] = useState(true);

	const updateImgState = (imgID, versionNo, isApproved) => {
		let imageDetail = {
			refTablename: 'property',
			eRefRecordid: visible,
			id: imgID,
			isApproved: isApproved,
			versionNo: versionNo,
		};
		setImageData((data) => [...data, imageDetail]);
	};

	const handleChange = (imgID, versionNo, checkboxValue) => {
		form.validateFields({ validateOnly: true })
			.then(() => {
				setDisabled(false);
			})
			.catch((err) => {
				setDisabled(true);
			});
		if (imageData.length) {
			const isExist = imageData.find((_x) => _x.id === imgID);
			if (isExist) {
				const removeExist = imageData.filter((_x) => _x.id !== imgID);
				setImageData(removeExist);
				updateImgState(imgID, versionNo, checkboxValue);
			} else {
				updateImgState(imgID, versionNo, checkboxValue);
			}
		} else {
			updateImgState(imgID, versionNo, checkboxValue);
		}
	};

	const handleSubmit = () => {
		AUTH.onApproveImage(imageData).then((data) => {
			if (data) {
				Notification.success({ message: Message().ImageApproved });
				closeModal();
			}
		});
		// onApproveImage;
	};

	const closeModal = () => {
		form.resetFields();
		setImageData([]);
		ACCOMMODATION.propertyImageDetails = null;
		setDisabled(true);
		onClose();
		ACCOMMODATION.getMerchantAccomodation(merchantId.merchantId);
	};
	return (
		<Modal
			title="Property Image Verification"
			onCancel={closeModal}
			open={visible}
			destroyOnClose
			width={'900px'}
			footer={
				<div>
					<Button
						key={1}
						htmlType="submit"
						type="primary"
						disabled={disabled}
						form="imageApprove"
					>
						Submit
					</Button>
					<Button key={2} onClick={closeModal}>
						Cancel
					</Button>
				</div>
			}
		>
			<Spin spinning={!propertyImageDetails}>
				<Form
					id={'imageApprove'}
					layout="vertical"
					form={form}
					onFinish={handleSubmit}
				>
					<Row gutter={24}>
						{propertyImageDetails && propertyImageDetails.length
							? propertyImageDetails.map((imageDetails, index) => {
								// Check if the file is a video
								const isVideo = imageDetails.filename?.toLowerCase().match(/\.(mp4|mov|avi|wmv)$/);

								return (
									<Col
										span={4}
										key={imageDetails.id} // Added key for better performance
										style={{ marginBottom: '20px' }}
									>
										<div style={{ width: '100%', aspectRatio: '1/1', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f0f0f0' }}>
											{isVideo ? (
												/* Render Video Player for Videos */
												<video
													src={imageDetails.bunnyLink}
													style={{ width: '100%', height: '100%', objectFit: 'cover' }}
													controls={false} // Keep it clean for the grid
													onMouseOver={e => e.currentTarget.play()} // Optional: play on hover
													onMouseOut={e => e.currentTarget.pause()}
												/>
											) : (
												/* Render Image for Photos */
												<Image
													src={`${imageDetails.bunnyLink}?width=300&&aspect_ratio=1:1`}
													alt={imageDetails.filename}
													style={{ width: '100%', height: '100%', objectFit: 'cover' }}
												/>
											)}
										</div>

										<div
											style={{
												marginTop: '8px',
												marginBottom: '5px',
												textAlign: 'center',
												wordBreak: 'break-word',
												fontSize: '12px',
												backgroundColor: '#f0f0f0',
												padding: '3px 8px',
												borderRadius: '10px',
												lineHeight: '16px',
											}}
										>
											{imageDetails.description || '-'}
										</div>

										<div
											style={{
												marginTop: '10px',
												textAlign: 'center',
											}}
										>
											<InputComponent
												type={'checkbox'}
												defaultChecked={imageDetails.isApproved}
												name={`checkbox_${index}`}
												label={'Approve'}
												onChange={(e) =>
													handleChange(
														imageDetails.id,
														imageDetails.versionNo,
														e.target.checked
													)
												}
											/>
										</div>
									</Col>
								);
							})
							: Message().noRecord}
					</Row>
				</Form>
			</Spin>
		</Modal>
	);
});

export default PropertyImageApproveModal;
